module.exports = __webpack_public_path__ + "media/Video 100.9391e757.mp4";